import React,{useState} from "react";
import Navbar from "../navbar/navbar";
import { api } from "../../services/api";
import { Link,Navigate,useParams } from 'react-router-dom'
import { useEffect } from "react";
import './grupo.css'
import { vhostV1, vhostV2 } from "../funcoes";
import SweetAlert from "react-bootstrap-sweetalert";
import FooterBar from "../footer/footerBar";
import semImagem from "../../images/semImagem.jpg";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import { NumericFormat } from "react-number-format";





function NovaLinha(props){

  document.addEventListener("keydown", function(e) {

    if(e.keyCode === 13) {
      
      e.preventDefault();
      
    }
  
  });

  const {tag} = useParams();
  const {id} = useParams();

   const [descricao,setDescricao]  = useState('');
   const [cor,setCor]              = useState('');
   const [carga,setCarga]          = useState("1");
   const [sucesso,setSucesso]      = useState('N');
   const [ctWeb, setCtWeb] = useState('0');
   const [file, setFile] = useState(null);
   const [mensagem, setMensagem]   = useState('');
   const [erroValidacao, setErrovalidacao] = useState(false);
   const [msgErro, setmsgErro] = useState('');
   const [isModalOpenImage, setIsModalOpenImage] = useState(false);
   const [imagemProduto, setImagemProduto] = useState(semImagem);
   const [autoAtendimento, setAutoAtendimento] = useState('')
   const [gruposCtWeb, setGruposCtWeb] = useState([]);
   const [buscaCtWeb, setBuscaCtWeb] = useState('');
   const [subGrupos, setSubGrupos] = useState([]);
   const [cod_subGrupo, setCod_subGrupo] = useState(0);
   const [cod_grupo, setCod_grupo] = useState(0);
   const [grupos, setGrupos] = useState([]);
   const [markup, setMarkup] = useState(0);
   const loja = localStorage.getItem('loja');
    
   let config = {
    headers: {
      'Authorization': localStorage.getItem("token")
    }
  }

  let config2 = {
    headers: {
      'Authorization': localStorage.getItem("token2")
    }
  }

  useEffect(function(){
       
          api.post(vhostV1('webcash/grupos'), {
              pagina: 1,
              regPag: 100,
              busca: "",
              cod_subgrupo: 1
            },config)
            .then(function (response) {
         
              
              setGrupos(response.data.dados);
              console.log(response); 
                                          
                       
            })
            .catch(function (error) {
             
              console.log(error);
    
                      
            });
               
            
        },[])

         useEffect(function(){
           
              api.post(vhostV1('webcash/subgrupos'),{
                  pagina: 1,
                  regPag: 100,
                  busca: "",
                  cod_grupo: Number(cod_grupo) 
                },config)
                .then(function (response) {

                  setSubGrupos(response.data.dados);
                  console.log(response); 
                                              
                           
                })
                .catch(function (error) {
                 
                  console.log(error);
        
                          
                });
                   
                
            },[cod_grupo])

   //buscar grupo se for edicao
  useEffect(function(){
    
    api.get(vhostV1('webcash/linhaProd/'+Number(id)),config)
      .then(function (response) {
        console.log(response);

       if(id !== '-1'){ 
        setDescricao(response.data.dados.DESCRICAO);
        setCod_subGrupo(response.data.dados.COD_SUBGRUPO);
        
       }
        
                 
      })
      .catch(function (error) {
       
        console.log(error);

                
      });

      
  },[])

  useEffect(function(){
      
      api.get(vhostV1('webcash/subgrupos/'+Number(cod_subGrupo)),config)
        .then(function (response) {
          console.log(response);
  
         if(id !== '-1'){ 
       
          setCod_grupo(response.data.dados.COD_GRUPO);
       
         }
          
                   
        })
        .catch(function (error) {
         
          console.log(error);
  
                  
        });
  
        
    },[cod_subGrupo])


     useEffect(function(){
      
        api.post(vhostV1("webcash/ftp/run"), {
      query: `SELECT 
      id as COD_GRUPO,
      nome as DESCRICAO,
      status as CARGA 
      FROM categorias WHERE rel_estabelecimentos_id = ${loja}
      AND nome LIKE '%${buscaCtWeb}%'`,
      params: []
    }, config)
    .then(res => {
      console.log(res.data);
      
      setGruposCtWeb(res.data.dados); 
    })
    .catch(err => console.error(err));
            
          
      },[buscaCtWeb])

  
   function salvaGrupo(e){
    e.preventDefault();
    // const sJson = {
    //   COD_GRUPO:Number(id),          
    //   DESCRICAO:descricao,
  
    //   CARGA:carga,
    // }

    // console.log(sJson);
    
    

    if(descricao.length === 0){  
      {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
          setErrovalidacao(true)}
      return    
  }else if(descricao === ' '){
    {setmsgErro("DESCRIÇÃO DO GRUPO NÃO PODE ESTAR VAZIO");
      setErrovalidacao(true)}
  }
    
    else{

        api.post(vhostV1('webcash/linhaProd/inclui'),{
            COD_LINHA:Number(id),
            COD_SUBGRUPO:Number(cod_subGrupo),          
            DESCRICAO:descricao,          
           
            
          },config)
        .then(function(response){
            setMensagem('');
            setSucesso('S');
            console.log(response)
        }).catch((erro) =>{
            setMensagem(erro);
            setSucesso('N');
        });
     } }


     return <div className="conteiner-fluid titulo ">
         <Navbar/>
         <div className="offset-lg-1 col-lg-10">
               <h2>Cadastro de Sub-Grupo</h2>      
               <hr />
                <div className="conteiner-fluid">
                <form className="row tela" onsubmit="return false;">

                  


                  <div className="col-md-3">
              <label htmlFor="inputState" className="form-label">
                GRUPO
              </label>
              <select
                id="inputGrupo"
                value={cod_grupo}
                onChange={(e) => setCod_grupo(e.target.value)}
                className="form-select"
                tabIndex="3"
              >
                <option value={0}>SELECIONE</option>
                {grupos.map((grupo) => {
                  return (
                    <option key={grupo.COD_GRUPO} value={grupo.COD_GRUPO}>
                      {grupo.COD_GRUPO} - {grupo.DESCRICAO}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="col-md-3">
              <label htmlFor="inputState" className="form-label">
                SUB-GRUPO
              </label>
              <select
                id="inputGrupo"
                value={cod_subGrupo}
                onChange={(e) => setCod_subGrupo(e.target.value)}
                className="form-select"
                tabIndex="3"
              >
                <option value={0}>SELECIONE</option>
                {subGrupos.map((grupo) => {
                  return (
                    <option key={grupo.COD_SUBGRUPO} value={grupo.COD_SUBGRUPO}>
                      {grupo.COD_SUBGRUPO} - {grupo.DESCRICAO}
                    </option>
                  );
                })}
              </select>
            </div>

                   
                   <div className="col-5">
                       <label htmlFor="inputAddress" className="form-label">DESCRICAO</label>
                       <input type="text"  value={descricao}  onChange={(e)=> setDescricao(e.target.value)} className="form-control" id="inputDescricao" tabIndex="1" required autoComplete="off" maxLength='20'/>
                   </div>
                  
                    
                 
                   
                   <div className="col-12">
                   <hr />
                       <Link to={`/app/linha/`} type="submit" className="btn btn-outline-primary butao"  tabIndex="14">Desistir</Link>
                       <button type="submit" onClick={salvaGrupo} className="btn btn-primary butao" tabIndex="13">Salvar</button>
                   </div>
       
                   {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
                   {sucesso === 'S' ? <Navigate to={`/app/linha/`}/> : null}
       
                   </form> 
            </div>

            {
           erroValidacao ? 
           <SweetAlert
              danger
              confirmBtnText="OK"
              confirmBtnBsStyle="danger"
              title="Erro"
              onConfirm={() => setErrovalidacao(false)}                            
            >
              {msgErro}
            </SweetAlert>:null
           
          }
        </div>  
        <FooterBar/>
   </div>

}



export default NovaLinha;